import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ExpandBottomIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M15.8333 2.5L4.16667 2.5C3.2475 2.5 2.5 3.2475 2.5 4.16667L2.5 15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V4.16667C17.5 3.2475 16.7525 2.5 15.8333 2.5ZM9.41083 12.2558L6.0775 8.9225C5.7525 8.5975 5.7525 8.06917 6.0775 7.74417C6.4025 7.41917 6.93083 7.41917 7.25583 7.74417L10 10.4883L12.7442 7.74417C13.0692 7.41917 13.5975 7.41917 13.9225 7.74417C14.2475 8.06917 14.2475 8.5975 13.9225 8.9225L10.5892 12.2558C10.2642 12.5817 9.73583 12.5817 9.41083 12.2558Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ExpandBottomIcon.propTypes = {
  sx: PropTypes.object,
};

export default ExpandBottomIcon;
